<div class="time_scale" [ngStyle]="setTimescaleStyle()">
    <div class="time_scale_line" [ngStyle]="setTimescaleLineStyle('none')">
        <div class="time_scale_cell" *ngFor="let date of timeScale" [ngStyle]="setTimescaleCellStyle()" [ngClass]="(isDayWeekend(date)) ? 'weekend' : ''">{{date | date: 'dd-MM-yyyy'}}</div>
    </div>
    <div *ngIf="zoomLevel === 'hours'" class="time_scale_line" [ngStyle]="setTimescaleLineStyle('1px solid #cecece')">
        <div class="time_scale_cell" *ngFor="let hour of getHours()" [ngStyle]="{ 'width': ganttService.hourCellWidth + 'px' }">{{hour}}</div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/gantt-chart/gantt-activity/gantt-time-scale/gantt-time-scale.component.html